import React, { useEffect, useRef } from 'react';
import LocaleContext from '../../state/contexts/LocaleContext'
import { Alert } from 'react-bootstrap';
import { BfButtonBlue, BfRowForm } from '../../Styling/styledForm/styledBlueForm'
import _ from 'lodash'
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux'
import { useKredittvurderingContainer } from './useKredittvurderingContainer';
import { OverlaySpinner } from '../../components/spinner/OverlaySpinner';
import { useAuth } from '../../hooks/useAuth'
import KredittvurderingViewComponent from './components/KredittvurderingViewComponent';
import { getAhlinCMSbyId } from '../../reduxStore/HeadlessCMS/headlessCmsActions';
import BislabTermsModal from './modals/BislabTermsModal';
import colorConfig from '../../colorConfig';
import { getDebitorList } from "../../reduxStore/newCase/newCaseActions"
import LogoImage from './image/bislab_kred.png';

const FieldLabel = styled.label`
  display: block;
//   margin-bottom: 5px;
  font-weight: 400;
`;

const CenteredContainer = styled.div`
    display: flex;
    justify-content: center; 
    flex-direction: column;
    align-items: center;
`;

const ArticleArea = styled.div`
   font-size: 20px;
   font-weight: 400;
   line-height: 33.6px;
   margin-bottom: 0px;
   width: 50%;
   font-family: "RM Neue", "sans-serif";
   color: ${colorConfig.tabellrad_tekst} !important;

   h1, h2, h3, h4, h5, h6{
    font-weight: 600;    
    margin-bottom: 10px;
    margin-top: 16px;
    font-size: 30px;
    color: black !important;
    }

    p{
        font-size: 20px;
        margin-top: 0px;
        margin-bottom: 10px;
    }
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`;

const StyledImage = styled.img`
    max-width: 300px;
    height: auto;
    object-fit: contain;
`;

const KredittvurderingContainer = () => {
    const showToasts = true
    const locale = React.useContext(LocaleContext);
    const { localeMessages, selectedKreditor, state, headerState, clearRatingData, getChosenRating, termsModal, deactivateModal, isAccepted, getRatingInfoManually }
        = useKredittvurderingContainer(locale)
    const crState = useSelector(state => state.sakslisteHeader)

    const searchHistoryData = state.searchHistoryData[0] ?? []
    const searchDataList = state.filteredList ?? [];

    let currentKreditor = headerState.kreditorliste.find(e => e.customerNo === headerState.kreditorId)
    const auth = useAuth()
    const userBislabDate = auth.user.bisLabDate ?? '';
    const articleId = 'kredittvurdering'
    const cmsArticlesState = useSelector(state => state.headlessCMS)
    const newCaseState = useSelector(state => state.newCase)

    const _dispatch = useDispatch()
    const hasFetched = useRef(false);

    useEffect(() => {
        // Ikke hent dersom det er unødvendig, da risikerer du å refreshe token
        // når idle logout modal vises, og auto logoff vil ikke fungere
        if (hasFetched.current) return;
        hasFetched.current = true;

        let fetchCMS = (!cmsArticlesState.data[articleId])
        if (fetchCMS) {
            _dispatch(getAhlinCMSbyId(articleId, showToasts, localeMessages))
        }
    }, [currentKreditor])

    // useEffect(() => {
    //     if ((currentKreditor) && currentKreditor.kredittvurdering && userBislabDate) {
    //         _dispatch(getDebitorList(selectedKreditor, true, localeMessages))
    //     }
    // }, [crState.kreditorliste, selectedKreditor, currentKreditor, isAccepted])

    const getInfo = (htmlContent) => {
        if (Array.isArray(htmlContent) && htmlContent.length > 0) {
            return (
                <div>
                    {htmlContent.map((item) => (
                        <div key={item.id}>
                            <h2 dangerouslySetInnerHTML={{ __html: item.title.rendered }}></h2>
                            <div dangerouslySetInnerHTML={{ __html: item.content.rendered }}></div>
                        </div>
                    ))}
                </div>
            )
        } else if (cmsArticlesState.loading) {
            return (
                <div style={{ color: '#666', fontFamily: "Fellix, sans-serif", fontSize: '16px', padding: '20px' }}>
                  Laster info...
                </div>
            )
        } else {
            return (
                <div style={{ color: 'red', textAlign: 'center', fontWeight: '600', fontFamily: "Fellix, sans-serif", fontSize: '20px' }}>
                  Noe gikk galt ved henting av informasjon, du kan fortsatt bruke Kunderportalen som vanlig.
                </div>
            )}
    }

    if (state.loading || newCaseState.loading) {

        return (
            <>
                <h2>{localeMessages['faSlow']}</h2>
                <OverlaySpinner />
            </>
        )

    } else if (state.error) {

        return (<Alert variant='danger'>{state.error}</Alert>)

    } else if (!selectedKreditor) {

        return (
            <>
                <Alert variant='danger'>{localeMessages['VelgKreditor']}</Alert>
                <ContentWrapper>
                    <ArticleArea>
                        {getInfo(cmsArticlesState.data[articleId] || '')}
                        <br />
                    </ArticleArea>
                    <StyledImage src={LogoImage} alt="Bislab og Kreditorforeningen logo" style={{ maxWidth: '300px', height: 'auto' }} />
                </ContentWrapper>
            </>
        )

    }
    // Verken bruker eller kreditor har signert avtalen.
    else if (selectedKreditor && !state.hasKredittvurdering && !auth.user.bisLabDate) {
        return (
            <>
                {termsModal.dialogVisible && <BislabTermsModal termsModal={termsModal} state={state} viewOnlyMode={false} />}

                <Alert variant='danger'>{localeMessages['ikkeKredittvurdering']}</Alert>
                <ContentWrapper>
                    <ArticleArea>
                        {getInfo(cmsArticlesState.data[articleId] || '')}
                        <br />
                        <CenteredContainer>
                            {(!auth.user.phonenumber || auth.user.phonenumber.trim() === '') && (
                                <p>Mangler mobilnummer på profil</p>
                            )}
                            <BfButtonBlue
                                style={{ width: '200px', height: '70px', fontSize: '22px' }}
                                variant="primary"
                                type="button"
                                title={!auth.user.phonenumber || auth.user.phonenumber.trim() === '' ? "Mangler mobilnummer på profil" : ''}
                                onClick={termsModal.showDialog}
                                disabled={!auth.user.phonenumber || auth.user.phonenumber.trim() === ''}>
                                {localeMessages.showTermsButton}
                            </BfButtonBlue>
                        </CenteredContainer>
                    </ArticleArea>
                    <StyledImage src={LogoImage} alt="Bislab og Kreditorforeningen logo" style={{ marginBottom: '70px'}} />
                </ContentWrapper>
                <br />
            </>
        );
    }
    // Bruker har ikke signert, men kreditor har blitt signert for av en annen bruker.
    else if (selectedKreditor && state.hasKredittvurdering && !auth.user.bisLabDate) {
        return (
            <>
                {termsModal.dialogVisible && <BislabTermsModal termsModal={termsModal} state={state} viewOnlyMode={false} />}

                <Alert variant='danger'>{localeMessages['brukerIkkeKredittvurdering']}</Alert>
                <ContentWrapper>
                    <ArticleArea>
                        {getInfo(cmsArticlesState.data[articleId] || '')}
                        <br />
                        <CenteredContainer>
                            {(!auth.user.phonenumber || auth.user.phonenumber.trim() === '') && (
                                <p>Mangler mobilnummer på profil</p>
                            )}
                            <BfButtonBlue
                                style={{ width: '200px', height: '70px', fontSize: '22px' }}
                                variant="primary"
                                type="button"
                                title={!auth.user.phonenumber || auth.user.phonenumber.trim() === '' ? "Mangler mobilnummer på profil" : ''}
                                onClick={termsModal.showDialog}
                                disabled={!auth.user.phonenumber || auth.user.phonenumber.trim() === ''}>
                                {localeMessages.showTermsButton}
                            </BfButtonBlue>
                        </CenteredContainer>
                    </ArticleArea>
                    <StyledImage src={LogoImage} alt="Bislab og Kreditorforeningen logo" style={{ marginBottom: '70px'}} />
                </ContentWrapper>
                <br />
            </>
        );
    }
    // Bruker har signert, men det har ikke blitt signert for kreditor.
    else if (selectedKreditor && !state.hasKredittvurdering && auth.user.bisLabDate) {
        return (
            <>
                {termsModal.dialogVisible && <BislabTermsModal termsModal={termsModal} state={state} viewOnlyMode={false} />}

                <Alert variant='danger'>{localeMessages['ikkeKredittvurdering']}</Alert>
                <ContentWrapper>
                    <ArticleArea>
                        {getInfo(cmsArticlesState.data[articleId] || '')}
                        <br />
                        <CenteredContainer>
                            {(!auth.user.phonenumber || auth.user.phonenumber.trim() === '') && (
                                <p>Mangler mobilnummer på profil</p>
                            )}
                            <BfButtonBlue
                                style={{ width: '200px', height: '70px', fontSize: '22px' }}
                                variant="primary"
                                type="button"
                                title={!auth.user.phonenumber || auth.user.phonenumber.trim() === '' ? "Mangler mobilnummer på profil" : ''}
                                onClick={termsModal.showDialog}
                                disabled={!auth.user.phonenumber || auth.user.phonenumber.trim() === ''}>
                                {localeMessages.showTermsButton}
                            </BfButtonBlue>
                        </CenteredContainer>
                    </ArticleArea>
                    <StyledImage src={LogoImage} alt="Bislab og Kreditorforeningen logo" style={{ marginBottom: '70px'}} />
                </ContentWrapper>
                <br />
            </>
        );
    }

    else {
        return (
            <KredittvurderingViewComponent
                localeMessages={localeMessages}
                tableData={state.searchHistoryData}
                state={state}
                headerState={headerState}
                selectedKreditor={selectedKreditor}
                ratingInfoData={searchHistoryData}
                searchHistoryList={searchDataList}
                termsModal={termsModal}
                deactivateModal={deactivateModal}
                getChosenRating={getChosenRating}
                clearRatingData={clearRatingData}
                getRatingInfo={getRatingInfoManually}
            />
        )
    }
}
export default KredittvurderingContainer
